import React, { useEffect, useRef } from 'react';
import styles from './Skills.module.css';
import { skills } from '../data/portfolio';

function SkillCard({ skill }) {
  const fillRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && fillRef.current) {
        fillRef.current.style.width = `${skill.level}%`;
        observer.disconnect();
      }
    }, { threshold: 0.3 });
    if (fillRef.current) observer.observe(fillRef.current.parentElement);
    return () => observer.disconnect();
  }, [skill.level]);

  return (
    <div className={styles.skillStack}>
      <div className={styles.card}>
        <div className={styles.name}>{skill.name}</div>
        <div className={styles.cat}>{skill.category}</div>
        <div className={styles.bar}>
          <div ref={fillRef} className={styles.fill} style={{ width: '0%' }} />
        </div>
      </div>
    </div>
  );
}

export default function Skills() {
  return (
    <div className={`${styles.grid} fade-in`} style={{ marginBottom: '64px' }}>
      {skills.map((s) => <SkillCard key={s.name} skill={s} />)}
    </div>
  );
}
